import React from 'react';
import { usePlanningActualState } from '../Context/index';

function AverageSellPriceTable({ years, categoryItem }) {
  const { checkVisible, getFieldValue, getTotalOfField } = usePlanningActualState();
  const averageSellPrice = [
    {
      keyName: 'plannedASP',
      name: 'Planned Average Sell Price',
    },
    {
      keyName: 'actualASP',
      name: 'Actual Average Sell Price',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {averageSellPrice.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {categoryItem?.subcategory &&
            categoryItem.subcategory.map((cat2Ele, iCat) => {
              return (
                <tr key={iCat}>
                  {averageSellPrice.map((salesItem, i) => {
                    const isVisible = checkVisible(salesItem.keyName);
                    return (
                      isVisible && (
                        <td key={i}>{getFieldValue(salesItem.keyName, yearIndex, currentYear, cat2Ele.subcategoryId._id, categoryItem?.categoryId?._id)}</td>
                      )
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            {averageSellPrice.map((item, i) => {
              const isVisible = checkVisible(item.keyName);
              return (
                isVisible && (
                  <td key={i}>
                    <b>{getTotalOfField(item.keyName, yearIndex, currentYear, categoryItem?.categoryId?._id)}</b>
                  </td>
                )
              );
            })}
          </tr>
        </tfoot>
      </table>
    );
  });
}
export default AverageSellPriceTable;
